
/**
 * Date formatter.
 */

const dateFormat = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'long',
  day: '2-digit'
})

/**
 * Format a date.
 */

export function formatDate(date) {
  return dateFormat.format(date)
}